import React, { useState, useEffect } from "react";
import "./Checkbox.scss";
import { updateCheck, lightOrDark } from "./CheckboxMethods";

interface CheckboxProps {
  name: string;
  label: string;
  required?: boolean;
  warning?: boolean;
  id: string;
  overrideChecked: boolean;
  labelClass: string;
  inputClass: string;
  color: string;
  handleChange: Function;
}

const Checkbox = (props: CheckboxProps) => {
  const [checked, setChecked] = useState(false);

  const { required, warning, id, overrideChecked, labelClass, inputClass } = props;

  useEffect(() => {
    if (overrideChecked != null) { 
      setChecked(overrideChecked) 
    }
  }, [overrideChecked])

  let isChecked: string = checked ? "is-checked" : "";
  let darkTheme: string = lightOrDark(props?.color) ? "dark-theme" : "";

  console.log(darkTheme)

  const inputAttributes: Object = {
    id: id || props?.name,
    name: props?.name || null,
    type: "checkbox",
    className: inputClass,
    checked: isChecked
  }
  return (
    <div className={`ter-checkbox ${isChecked}`}>
      <label
        className={`ter-checkbox__label ${darkTheme} ${labelClass ? labelClass: ""} ${warning &&
          "ter-checkbox__label--warning"}`}
        style={{
          color: `${props?.color}` || "#242D2F",
        }}
        htmlFor={id || props?.name}
      >
        {required && (
          <span
            className="ter-checkbox__label-req"
            style={{ color: `${props?.color}` || "#242D2F" }}
          >
            *
          </span>
        )}
        {props?.label}
      </label>
      <input {...inputAttributes}
        onChange={(e) => updateCheck(e, setChecked, props.handleChange)}
      />
    </div>
  );
};

export default Checkbox;
